<template>
	<footer id="footer">

		<section class="extra-section">
			<div class="container oversized-container">
				<div class="box-alert">
					<div class="col col-icon">
						<i class="fa-light fa-triangle-exclamation icon"></i>
					</div>

					<div class="col col-text">
						<ul>
							<li>
								<p>Compruebe cuidadosamente la pieza (entradas, salidas, tornillos, pivotes, clips, roscas).<br />
									Ante cualquier duda contáctenos para apoyarlo a realizar su compra exitosa. No contamos con devolución, solo cambio.</p>
							</li>
							<li>
								<p>
									Las imágenes son reales, son tomadas directamente del producto que recibirá.
								</p>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</section>

		<section class="newsletter-section">
			<div class="container oversized-container">
				<div class="row align-items-center row-top">
	        <div class="col-lg-5 col-left col-newsletter">
	          <b-form @submit="onSubmit">
	            <b-form-input
	              v-model="form.email"
	              type="email"
	              placeholder="Escribe tu correo..."
	              required
	            ></b-form-input>

	            <b-button type="submit" class="btn-submit">Inscribirse</b-button>
	          </b-form>
	        </div>

	        <div class="col-lg col-middle">
	          <h6>Sé el primero en enterarte</h6>
	          <h4>Regístrate a nuestro newsletter</h4>
	        </div>

	        <div class="col-lg row mx-0 col-right">
	          <div class="box-networks">
							<a class="t-150 btn-network fb" target="_blank" href="https://www.instagram.com/hulesbecerragdl/"><i class="fab fa-instagram"></i></a>
							<a class="t-150 btn-network fb" target="_blank" href="https://es-la.facebook.com/pages/category/Motor-Vehicle-Company/HULES-Automotrices-Becerra-GDL-1080741468667230/"><i class="fab fa-facebook-f"></i></a>
	            <a class="t-150 btn-network ig" target="_blank" href="https://wa.me/5213317283818"><i class="fa-brands fa-whatsapp"></i></a>
							<!-- <a class="t-150 btn-network ig" target="_blank" href=""><i class="fab fa-instagram"></i></a> -->
	            <!-- <a class="t-150 btn-network tw" href="#"><i class="fab fa-twitter"></i></a> -->
	            <!-- <a class="t-150 btn-network lk" href="#"><i class="fab fa-linkedin-in"></i></a> -->
	          </div>
	          <router-link class="logo" to="/"><img src="public/images/logo.png"></router-link>
	        </div>
	      </div>
			</div>
		</section>

		<section class="footer-section">
			<div class="container oversized-container">
				<hr />

				<div class="row">
					<div class="col-md-6 col-lg-3 col-footer">
						<h6 class="title">Llámanos</h6>

						<p>
							01 (33) 3646 0945<br />
							01 (33) 3587 7736<br />
							01 (33) 3367 4895
						</p>
					</div>

					<div class="col-md-6 col-lg-3 col-footer">
						<h6 class="title">Oficinas</h6>

						<p>
							Av. Cruz del Sur No. 3237<br />
							Guadalajara, Jalisco.
						</p>
					</div>

					<div class="col-md-6 col-lg-3 col-footer">
						<h6 class="title">Contáctanos</h6>

						<p>
							contacto@hulesbecerra.com
						</p>
					</div>

					<div class="col-md-6 col-lg-3 col-footer">
						<h6 class="title">Horario</h6>

						<p>
							Lunes a Viernes de 9:00 AM a 6:30 PM<br />
	            Sábados de 9:00 AM a 2:00 PM
						</p>
					</div>

					<div class="col-12 col-menu">
						<div class="row">
							<div class="col-lg-7 col-l">
								<router-link class="link" to="/preguntas-frecuentes">Preguntas Frecuentes</router-link>
								<router-link class="link" to="/garantia">Garantia</router-link>
								<router-link class="link" to="/aviso-de-privacidad">Aviso de privacidad</router-link>
							</div>

							<div class="col-lg-5 col-r">
								<h6 class="copy">
									Copyright {{ currentYear }}, Hules Automotrices Becerra
								</h6>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

	</footer>
</template>

<script type="text/javascript">
export default {
	data(){
    return{
      currentYear: 0,

      form: {
        email: null
      },
      info: {
        email:null,
        contact:null,
        address:null,
      },
    }
  },

  methods:{
    makeToast(variant = null, msg, title) {
      this.$bvToast.toast(msg, {
        title: title,
        variant: variant,
        solid: true,
        toaster: 'b-toaster-top-right',
        appendToast: true
      });
    },

    onSubmit(evt) {
      evt.preventDefault();
      var r = confirm("¿Deseas regístrate en newsletter? ");
      if (r == true) {
        axios.post(tools.url("/api/newsletter"), this.form).then((response)=>{
          this.makeToast('default', response.data.response, 'Correo registrado');
          this.form = {
            name: null,
            email: null,
            msg: null,
            check: null
          };
        }).catch( (error)=> {
          // console.log(error.response);
          let errors = error.response.data;
          // console.log(errors);
          this.makeToast('danger', error.response.data.name, 'Error');
          this.makeToast('danger', error.response.data.email, 'Error');
          this.makeToast('danger', error.response.data.phone, 'Error');
          this.makeToast('danger', error.response.data.msg, 'Error');
        });
      }
    },
  },

  beforeMount(){
    this.currentYear = new Date().getFullYear();
  }
}
</script>
